import ExperimentKey from "../../Experiment/types/ExperimentKey";
import ExperimentalFlowResolver from "../types/ExperimentalFlowResolver";
import { Flow } from "../types/IFlow";
import { NoConfirmationNoBookFlowLegacyNames } from "../types/FlowNames";
import {
  SingleMedicalStepDefaultNavigatorConfiguration,
  SingleMedicalStepPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import NoConfirmationNoBookFlow, { PreQualifiedNoConfirmationNoBookFlow } from "./NoConfirmationNoBookFlow";
import {
  experimentalScreeningStepConfigurations,
  noConfirmationCenterSelectableBookingStepConfigurations
} from "./StepConfigurations";

const singleMedicalStepNoBookFlowName = "SingleMedicalStepNoBookFlow";

/** The treatment flow where a no-book guest experiences the single-page medical presentation. */
class SingleMedicalStepNoBookFlow extends Flow {
  static readonly flowName = singleMedicalStepNoBookFlowName;
  readonly name = singleMedicalStepNoBookFlowName;
  readonly steps = {
    ...experimentalScreeningStepConfigurations,
    ...noConfirmationCenterSelectableBookingStepConfigurations
  };
  readonly navigatorItems = SingleMedicalStepDefaultNavigatorConfiguration;
  isDisqualificationPossible() {
    return true;
  }
  override matchesFlowName(name: string): boolean {
    return this.name === name || NoConfirmationNoBookFlowLegacyNames.includes(name);
  }
}

/** The treatment flow for pre-qualified no-book guests (scheduling-only path). */
export class PreQualifiedSingleMedicalStepNoBookFlow extends Flow {
  readonly name = singleMedicalStepNoBookFlowName;
  readonly steps = { ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = SingleMedicalStepPreQualifiedPatientNavigatorConfiguration;
  isDisqualificationPossible() {
    return false;
  }
  override matchesFlowName(name: string): boolean {
    return this.name === name || NoConfirmationNoBookFlowLegacyNames.includes(name);
  }
}

export default SingleMedicalStepNoBookFlow;

/** Resolves no-book flows through the single-medical-step experiment when the session flow name matches the control family. */
export const SingleMedicalStepNoBookFlowResolver = new ExperimentalFlowResolver(
  new SingleMedicalStepNoBookFlow(),
  new NoConfirmationNoBookFlow(),
  ExperimentKey.SingleMedicalStepFlow
);

/** Resolves pre-qualified no-book flows through the single-medical-step experiment. */
export const PreQualifiedSingleMedicalStepNoBookFlowResolver = new ExperimentalFlowResolver(
  new PreQualifiedSingleMedicalStepNoBookFlow(),
  new PreQualifiedNoConfirmationNoBookFlow(),
  ExperimentKey.SingleMedicalStepFlow
);
